export enum Product {
  Chat = 'chat',
  ActivityFeeds = 'activity-feeds',
  Video = 'video',
}

export type Step = {
  id: number;
  label: string;
  completed: boolean;
  optional?: boolean;
  steps?: Step[];
};

export type Content = {
  title: string;
  paragraphs?: string[];
  blockquotes?: string[];
  icon?: string;
};

export type Conclusion = {
  conclusion: string;
  components: { icon: string; label: string; to: string }[];
  docs: {
    label: string;
    to: string;
  };
};

export type State = {
  steps: Step[];
  current: number;
  first: number;
  last: number;
  showPrev: boolean;
  showNext: boolean;
  modal?: {
    title: string;
    content: string;
  };
};

export enum Actions {
  SetComplete = 'setComplete',
  GoTo = 'goTo',
  GoNext = 'goNext',
  GoPrev = 'goPrev',
  ShowModal = 'showModal',
  HideModal = 'hideModal',
}

export type Action =
  | { type: Actions.SetComplete; step: number; parentStep: number }
  | { type: Actions.GoTo; to: number }
  | { type: Actions.GoNext }
  | { type: Actions.GoPrev }
  | { type: Actions.ShowModal; modal: { title: string; content: string } }
  | { type: Actions.HideModal };
